import { APIResponse, APIStatus } from '@Src/services/baseInterfaces';
import { useEffect, useState } from 'react';
import HomeLayout from '../layout/components/HomeLayout/HomeLayout';
import DetailsPageBanner from '@Components/DetailsPageBanner/DetailsPageBanner';
import { SubscriptionUpdates } from '@Components/SubscriptionUpdates/SubscriptionUpdates';
import { MockTestSeries } from './Components/MockTestSeries/MockTestSeries';
// import { getTestSeriesList } from '../TestDetails/services/TestDetails.service';
import { HeaderNameKeys } from '@Constants/app.constant';
import { TestSeriesAllFilter } from './Components/TestSeriesAllFilter/TestSeriesAllFilter';
import { FILTER_KEYS, FILTER_LIST } from '../Filter/Constants/filters.constants';
import { useAppSelector } from '@App/hooks';
import { getLanguageList, getBoardlist, getClassList } from '../UserProfile/Services/UserProfile.sevice';
import { getTestSeriesListAll } from '../TestDetails/services/TestDetails.service';
import { TestSeriesSkeleton } from '@Components/TestSeriesSkeleton/TestSeriesSkeleton';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRouteURL } from '@Constants/app-route-url.constant';

const TestSeriesDetailsIndex = () => {
    const [mockTestSeriesList, setMockTestSeriesList] = useState<Array<any>>([]);
    const [headingsBreadcrumb, setHeadingsBreadcrumb] = useState<Array<any>>([{ name: 'Mock Test', type: HeaderNameKeys.ALL_TEST_SERIES }]);
    const [page, setPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [currentParams, setCurrentParams] = useState<any>({});

    const [initialFilters, setInitialFilters] = useState<Array<any>>([]);
    const [filters, setFilters] = useState<any>({});
    const coursePreferences = useAppSelector((state: any) => state.coursePreferences);
    const loginData = useAppSelector((state: any) => state.login);
    const navigate = useNavigate();
    const location = useLocation();
    // Redirect logic removed to allow institute users to access the page and see the Visit Mock Test button
    // useEffect(() => {
    //     if (loginData?.isLoggedIn && loginData?.InstituteId) {
    //         navigate(AppRouteURL.HOME);
    //     }
    // }, [loginData, navigate]);

    const getHeadingFromSubmitFilters = (filters: any) => {
        let updatedBreadrumb: any = [
            { name: 'Practice Test', type: HeaderNameKeys.ALL_TEST_SERIES }
        ];

        // Add Class to breadcrumb
        // const activeClass = filters[FILTER_KEYS.CLASS];
        // if (activeClass) {
        //     // Handle both array and single object
        //     const classObj = Array.isArray(activeClass) ? activeClass[0] : activeClass;
        //     if (classObj && classObj.Name) {
        //         updatedBreadrumb.push({
        //             name: classObj.Name,
        //             type: HeaderNameKeys.CLASS
        //         });
        //     }
        // }

        // Add Subject to breadcrumb
        // const activeSubjects = filters[FILTER_KEYS.SUBJECT];
        // if (activeSubjects) {
        //     const subjects = Array.isArray(activeSubjects) ? activeSubjects : [activeSubjects];
        //     if (subjects.length > 0) {
        //         const subjectNames = subjects.map((s: any) => s.Name).filter(Boolean).join(', ');
        //         // if (subjectNames) {
        //         //     updatedBreadrumb.push({
        //         //         name: subjectNames,
        //         //         type: HeaderNameKeys.SUBJECT
        //         //     });
        //         // }
        //     }
        // }

        setHeadingsBreadcrumb(updatedBreadrumb);
    }

    useEffect(() => {
        let param: any = {};
        let initialFilters: any = [];

        const board = coursePreferences?.boardDetails?.[0];
        const classDetail = coursePreferences?.classDetails?.[0];

        if (board?.Id) {
            initialFilters.push({ [FILTER_KEYS.BOARD]: board });
        }
        if (classDetail?.Id) {
            param[FILTER_KEYS.CLASS] = classDetail.Id;
            initialFilters.push({ [FILTER_KEYS.CLASS]: classDetail });
        }

        if (loginData?.isLoggedIn && loginData?.LanguageId) {
            param.languageId = [loginData.LanguageId];
            const langName = loginData.LanguageName || 'Language';
            const langObj = { Id: loginData.LanguageId, Name: langName };
            initialFilters.push({ [FILTER_KEYS.LANGUAGE]: langObj });

            // Also ensure this language is in the filters list so the dropdown can show it
            setFilters((prev: any) => ({
                ...prev,
                [FILTER_LIST.LANGUAGE]: [langObj]
            }));
        }

        // Fetch full language list
        getLanguageList().then((response: any) => {
            if (response?.ResponseType === 'SUCCESS') {
                setFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.LANGUAGE]: response.data || []
                }));
            }
        }).catch((error) => {
            console.error('Error fetching language list:', error);
        });

        // Fetch Board list for logged out users
        if (!loginData?.isLoggedIn) {
            getBoardlist().then((response: any) => {
                if (response?.ResponseType === 'SUCCESS') {
                    setFilters((prev: any) => ({
                        ...prev,
                        [FILTER_LIST.BOARD]: response.data || []
                    }));
                }
            }).catch((error) => {
                console.error('Error fetching board list:', error);
            });
        }

        setInitialFilters(initialFilters);

        // Set initial breadcrumb based on course preferences
        const initialBreadcrumbFilters = {
            [FILTER_KEYS.CLASS]: classDetail
        };
        getHeadingFromSubmitFilters(initialBreadcrumbFilters);

        getALLMockTestSeries(param, 1);
    }, [coursePreferences, loginData]);


    function getALLMockTestSeries(param: any = {}, pageNum: number = 1) {
        if (pageNum === 1) {
            setCurrentParams(param);
            setPage(1);
            setIsLoading(true);
        } else {
            setIsLoadingMore(true);
        }

        //limit=20 is default
        const payload = { ...param, page: pageNum, limit: 20 };
        getTestSeriesListAll(payload).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                let data = response?.data;
                const newResults = data.result || [];
                setTotalRecords(data.total_record || 0);

                if (pageNum === 1) {
                    setMockTestSeriesList(newResults);
                } else {
                    setMockTestSeriesList(prev => [...prev, ...newResults]);
                }
                setIsLoading(false);
                setIsLoadingMore(false);
            } else {
                setIsLoading(false);
                setIsLoadingMore(false);
            }
        }).catch(() => {
            setIsLoading(false);
            setIsLoadingMore(false);
        })
    }

    const submitFilters = (filters: any) => {
        let newFilters: any = { ...filters };
        Object.keys(newFilters).map((filter: any) => {
            newFilters[filter] = newFilters[filter] != undefined || newFilters[filter] != null ? newFilters[filter] : delete newFilters[filter];
        });
        getHeadingFromSubmitFilters(filters);
        let params = modifiedFilters(newFilters);
        if (loginData?.isLoggedIn && loginData?.LanguageId && !params.languageId) {
            params.languageId = [loginData.LanguageId];
        }
        getALLMockTestSeries(params, 1);
    }

    // Add callback to update class list
    submitFilters.updateClasses = (classData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.CLASS]: classData
        }));
    };

    // Add callback to update subjects
    submitFilters.updateSubjects = (subjectData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.SUBJECT]: subjectData
        }));
    };

    // Add callback to update chapter list
    submitFilters.updateChapters = (chapterData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.CHAPTER]: chapterData
        }));
    };

    // Add callback to update topic list
    submitFilters.updateTopics = (topicData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.TOPIC]: topicData
        }));
    };

    // Add callback to update difficulty levels
    submitFilters.updateDifficultyLevels = (difficultyData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.DIFFICULTY]: difficultyData
        }));
    };

    // Fetch difficulty levels on mount
    useEffect(() => {
        import('../TestDetails/services/TestDetails.service').then(({ getDifficultyLevels }) => {
            getDifficultyLevels().then((response: any) => {
                if (response?.ResponseType === 'SUCCESS') {
                    setFilters((prev: any) => ({
                        ...prev,
                        [FILTER_LIST.DIFFICULTY]: response.data || []
                    }));
                }
            });
        });
    }, []);

    const handleLoadMore = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        getALLMockTestSeries(currentParams, nextPage);
    }

    const modifiedFilters = (filters: any) => {
        let payload: any = {};
        let keys = Object.keys(filters);
        keys.forEach((key) => {
            if (key === 'previousYearCheck' && filters[key]) {
                payload[key] = filters[key];
            } else if (key === 'keyWord' && filters[key]) {
                payload[key] = filters[key];
            } else if (filters[key] && typeof (filters[key]) == 'object') {
                if (Array.isArray(filters[key])) {
                    if (filters[key].length > 0) {
                        const ids = filters[key].map((filter: any) => filter.Id);
                        payload[key] = ids;
                    }
                } else {
                    if (filters[key].Id !== undefined && filters[key].Id !== null) {
                        if (key === FILTER_KEYS.DIFFICULTY || key === FILTER_KEYS.CHAPTER || key === FILTER_KEYS.TOPIC || key === FILTER_KEYS.LANGUAGE || key === FILTER_KEYS.SUBJECT) {
                            payload[key] = [filters[key].Id];
                        } else {
                            payload[key] = filters[key].Id;
                        }
                    }
                }
            }
        });
        return payload
    }


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <>
            <HomeLayout >
                {/* <!-----------------------------------test-listining-section-------------------------------> */}
                <div className="test-listining">
                    <DetailsPageBanner Headings={headingsBreadcrumb} />
                    <TestSeriesAllFilter
                        filters={{
                            ...filters,
                            [FILTER_LIST.BOARD]: filters[FILTER_LIST.BOARD] || coursePreferences?.boardDetails || [],
                            [FILTER_LIST.CLASS]: filters[FILTER_LIST.CLASS] || coursePreferences?.classDetails || [],
                            [FILTER_LIST.SUBJECT]: filters[FILTER_LIST.SUBJECT] || coursePreferences?.subjectDetails || [],
                        }}
                        submitFilters={submitFilters}
                        initialFilters={initialFilters}
                        mockTestSeriesList={mockTestSeriesList}
                    />
                    {isLoading ? (
                        <TestSeriesSkeleton />
                    ) : (
                        <MockTestSeries
                            mockTestSeriesList={mockTestSeriesList}
                            onLoadMore={handleLoadMore}
                            hasMore={mockTestSeriesList.length < totalRecords}
                            loading={isLoadingMore}
                        />
                    )}
                    <SubscriptionUpdates />
                </div>
                {/* <!----------------------------------end-test-listining-section------------------------------->  */}
            </HomeLayout>

        </>
    );
}

export default TestSeriesDetailsIndex;
